import axios from 'axios';

const httpRequest = axios.create({
    baseURL: "https://sunucu.reposis.com:16665/",
});

export default httpRequest;